import { render, staticRenderFns } from "./showBalancesDialog.vue?vue&type=template&id=543f916c&scoped=true"
import script from "./showBalancesDialog.vue?vue&type=script&lang=js"
export * from "./showBalancesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543f916c",
  null
  
)

export default component.exports